<template>
  <!-- <div v-show="isShow" class="audio-enter"> -->
  <div style="flex: 1">
    <!-- 不能使用 van-button -->
    <div
      ref="voiceBtn"
      v-show="!sendBtnLoading"
      class="btn left-input speak-btn"
      @touchstart.prevent="touchstart"
      @touchend.prevent="touchend"
      @touchmove.prevent="touchmove"
      :style="{
        backgroundColor: textStatus.backgroundColor,
        color: textStatus.color,
      }"
    >
      {{ textStatus.text }}
      <!-- {{
        blackBoxSpeak
          ? beginRecoding
            ? "松开完成，上滑取消"
            : "按住说话"
          : "松开取消"
      }} -->
    </div>
    <div v-show="sendBtnLoading" class="btn left-input speak-btn">
      <van-loading size="20px" />
    </div>

    <!-- <van-overlay :show="isShow" @click="close" class-name="custom-overlay">
      <div class="audio-pie" @click.stop>
        <div v-show="beginRecoding && nowDuration > 0">
          <div class="audio-pie_audio--times" v-if="nowDuration">
            {{ showTime }}
          </div>
          <div v-show="false" class="audio-pie_audio--osc">
            <canvas id="canvas"></canvas>
          </div>
          <div v-if="drawColuList.length > 0" class="audio-pie_audio--osc">
            <div
              class="audio-pie_audio--osc_item"
              v-for="(item, idx) in drawColuList"
              :key="idx"
              :style="{ height: item + 'px' }"
            ></div>
          </div>
        </div>
        <div v-show="beginRecoding && nowDuration == 0" class="waitting">
          请稍后
        </div>
        <div class="audio-pie_txt" :class="{ 'red-color': !blackBoxSpeak }">
          {{
            blackBoxSpeak
              ? beginRecoding
                ? "松开发送，上滑取消"
                : "按住说话"
              : "松开取消"
          }}
        </div>
      </div>
    </van-overlay> -->
  </div>
</template>
<script>
import Recorder from "js-audio-recorder";
import { Toast } from 'vant'
// import { baiduASRApi } from "@/api/baiduASR";
// const lamejs = require("lamejs");
/**
 * @param isShow 是否显示音频录入组件
 * @param closeAudio 关闭音频录入组件或录音完毕的事件
 */
export default {
  props: {
    sendBtnLoading: {
      type: Boolean,
      default: false,
    },
  },
  inject: [
    "playAudio",
    "playVideo",
    "stopAllMedia",
    "getMyAudio",
    "baiduASR",
    "changeASRShow",
    "changeASRText",
  ],
  data() {
    return {
      isTouchstart: false,
      isShow: false,
      beginRecoding: false, // 开始录音
      blackBoxSpeak: false, // 是否上滑取消
      startY: "", // 手指滑动开始Y轴坐标
      touchFaultToleranceValue: 10, // 上划取消容错值
      timeOutEvent: 0, // 定时器

      waveCanvas: null,
      ctx: null,
      recorder: null, // 音频录入的实例
      drawRecordId: null, // 音频绘画波动图时的音频id
      nowDuration: 0, // 当前时长 秒
      limitDuration: 60, // 限制时长，单位-秒
      drawColuList: [], // 录音时的柱状波动图，数据集合

      haveRecordPermission: false,

      canUse: false,

      asrStartText: "录音中",
    };
  },
  computed: {
    showTime() {
      let d = this.nowDuration;
      d = Number(d) < 10 ? '0' + d : d;
      return (d = "0:" + d);
    },
    textStatus() {
      let status = "none";

      // 如果 this.blackBoxSpeak 为真（即真值），那么条件表达式的结果会根据 this.beginRecoding 的值来确定：
        //如果 this.beginRecoding 为真，则 status 被赋值为 "ing"。
        //如果 this.beginRecoding 为假，则 status 被赋值为 "none"。
      //如果 this.blackBoxSpeak 为假（即假值），那么 status 被赋值为 "cancel"。
      status = this.blackBoxSpeak
        ? this.beginRecoding
          ? "ing"
          : "none"
        : "cancel";
      // 放上面，有优先级问题
      /* if (this.nowDuration < 1) {
        status = "wait";
      }

     */

      if (!this.beginRecoding) {
        status = "none";
      }

      console.warn(
        "🚀 ~ file: AudioEnter.vue:121 ~ textStatus ~ status : ",
        status,
        this.blackBoxSpeak,
        this.beginRecoding
      );

      // {{
      //   blackBoxSpeak
      //     ? beginRecoding
      //       ? "松开完成，上滑取消"
      //       : "按住说话"
      //     : "松开取消"
      // }}
      let object = {
        text: "按住说话",
        backgroundColor: "#363636",
        color: "#fff",
      };
      switch (status) {
        case "none":
          object = {
            text: "按住说话",
            backgroundColor: "#363636",
            color: "#fff",
          };
          break;
        case "ing":
          object = {
            text: "松开完成，上滑取消",
            backgroundColor: "#1edf41",
            color: "#fff",
          };
          break;
        case "cancel":
          object = {
            text: "松开取消",
            backgroundColor: "#ee0a24",
            color: "#fff",
          };
          break;
        case "wait":
          object = {
            text: "请稍后",
            backgroundColor: "#ed6a0c",
            // backgroundColor: "#ff976a",
            color: "#fff",
          };
        default:
          break;
      }
      return object;
    },
  },
  watch: {
    showTime(n) {
      this.changeASRShow(true)
      this.changeASRText(`${this.asrStartText} ${n}`, false, this.textStatus);
    },
    // isShow: {
    //   handler(nv, ov) {
    //     if (nv) {
    //       // this.getPermission();
    //     } else {
    //       this.destroyRecorder();
    //     }
    //   },
    //   deep: true,
    // },
    // isShow(n, o) {
    //   if (!n) {
    //     this.destroyRecorder();
    //   }
    // },
  },
  mounted() {
    // this.getPermission();
    // 监听释放事件
    document.addEventListener("mouseup", this.documentMouseup);
  },
  beforeDestroy() {
    this.destroyRecorder();
    document.removeEventListener("mouseup", this.documentMouseup);
  },
  methods: {
    documentMouseup() {
      if (this.isTouchstart) {
        console.error(`🚀 document.addEventListener("mouseup",  松手了 触发了`);
        this.touchend();
      } else {
        console.error(
          `🚀 document.addEventListener("mouseup",  松手了但是 没 触发`
        );
      }
    },
    initRecord() {
      // 获取权限和初始化录音机 设置时长变化的监听与显示时长
      // this.destroyRecorder();
      console.log('enter initRecord ' + this.formatTime(new Date()))
      if (!this.haveRecordPermission){
        this.getPermission();
      }
      /* this.getPermission();
      if (!this.permissioned) {
        this.$myToast({
          type: "fail",
          message: "麦克风权限被拒绝",
        });
        this.closeAudio();
        return false;
      } */

      if (!this.vuex_baidu_asr_token) {
        this.$myToast({
          type: "fail",
          message: "无 ASR Token",
        });
        this.closeAudio();
        return false;
      }

      console.log('初始化录音机和监听时长')
      // 创建录音实例
      if (this.recorder ===null){
        this.recorder = new Recorder({
          sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
          // sampleRate: 48000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值
          sampleRate: 16000,
          numChannels: 1, // 声道，支持 1 或 2， 默认是1
          // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
        });
        // 监听录音变化
        const vm = this;
        this.recorder.onprogress = (params) => {
          if (Math.floor(params.duration) > this.limitDuration) {
            vm.touchend();
          }

          const d = Math.floor(params.duration);

          // d = Number(d) < 10 ? "0" + d : d;
          // d = "0:" + d;
          if (this.nowDuration !== d) {
            vm.$set(vm, 'nowDuration', d); // 不能直接等于来赋值
          }

          // console.log('--------------START---------------')
          // console.log("录音时长(秒)", params.duration);
          // console.log('录音大小(字节)', params.fileSize);
          // console.log('录音音量百分比(%)', params.vol);
          // console.log('当前录音的总数据([DataView, DataView...])', params.data);
          // console.log('--------------END---------------')
        };
      }


      // this.startCanvas();

      return true;
    },
    judgeCanUse() {
      // this.destroyRecorder();
      if (this.recorder !== null && this.haveRecordPermission){
        console.log('judgeCanUse true')
        return true
      } else {
        console.log('judgeCanUse false because：')
        if (this.recorder === null){
          console.log('judgeCanUse false：this.this.recorder === null')
        }
        if(!this.haveRecordPermission){
          console.log('judgeCanUse false：this.haveRecordPermission：' + this.haveRecordPermission)
        }
        const initRecordResult = this.initRecord()
        console.log('initRecordResult:' + initRecordResult)
        return initRecordResult
      }
    },
    // 获取麦克风权限
    getPermission() {
      if (this.permissioned) {
        return;
      }
      // 弹出授权窗时，会中断音频
      this.stopAllMedia("getPermission");
      // 没授权，不开面板
      this.closeAudio();
      // navigator.mediaDevices.getUserMedia({ audio: true })
      //   .then(function(stream) {
      //     // 用户授予录音权限
      //     // 在这里初始化录音功能或者进行其他操作
      //   })
      //   .catch(function(error) {
      //     // 用户拒绝了录音权限
      //     console.error('Error accessing microphone:', error);
      //   });

      // 由于申请权限到赋予权限 需要1s左右的时间 按钮先置灰
      this.permissionTimer = setTimeout(() => {
        this.changeASRShow(true);
        this.changeASRText("录音权限申请中", false, this.textStatus);
      }, 200);

      Recorder.getPermission().then(
        () => {
          this.haveRecordPermission = true;
          console.log("录音给权限了")
          if (this.permissionTimer){
            clearTimeout(this.permissionTimer)
            this.permissionTimer = null
          }
          this.changeASRShow(false);
          if (this.recorder == null){
            this.initRecord()
          }
        },
        (error) => {
          this.haveRecordPermission = false;
          if (this.permissionTimer){
            clearTimeout(this.permissionTimer)
            this.permissionTimer = null
          }
          this.changeASRShow(false);
          console.log('获取麦克风权限错误:', error)
          this.$myToast({
            type: "fail",
            message: error.message || "无麦克风权限",
          });
          console.error(
            `Recorder.getPermission error == ${error.name} : ${error.message}`
          );
        }
      );
    },
    cancelBtn() {
      if (this.isTouchstart) {
        this.blackBoxSpeak = false;
        this.touchend();
      }
    },
    // 波浪图canvas 配置
    // startCanvas() {
    //   //录音波浪
    //   this.waveCanvas = document.getElementById("canvas");
    //   this.waveCanvas.width = 145;
    //   this.waveCanvas.height = 44;
    //   this.ctx = this.waveCanvas.getContext("2d");
    // },
    // 手指开始触发
    touchstart(e) {
      console.log('按下开始' + this.formatTime(new Date()))
      this.isTouchstart = true;
      this.stopAllMedia("touchstart");
      // this.canUse = this.judgeCanUse() // this.initRecord();

      this.canUse = this.initRecord();
      if (!this.canUse) {
        console.log('*** 按下开始后却不能使用 马上噶了')
        Toast.fail('录音机尚未工作，请重试')
        this.cancelBtn();
        return;
      }

      this.isShow = true;

      this.changeASRShow(true);

      this.changeASRText("请稍后", false, this.textStatus);

      this.blackBoxSpeak = true;
      const client = this.$refs?.voiceBtn?.getBoundingClientRect();
      // this.startY = e?.targetTouches[0]?.clientY;
      this.startY = client?.top - this.touchFaultToleranceValue; // 容错
      this.timeOutEvent = 0;
      // 长按1000毫秒后执行
      this.timeOutEvent = setTimeout(() => {
        // 用 watch showTime 来展示
        // this.changeASRText(this.asrStartText);
        this.changeASRShow(true);
        this.startRecorder();
        this.beginRecoding = true;
      }, 1000 * 0.2);
      return false;
    },
    // 手指离开屏幕触发 录音结束
    touchend() {
      console.log('已抬起')
      this.isTouchstart = false;
      if (!this.canUse) {
        console.log('*** 抬起后还是不能使用 且马上噶了')
        return;
      }
      // 清空定时器
      clearTimeout(this.timeOutEvent);
      if (this.timeOutEvent !== 0) {
        this.beginRecoding = false;

        this.stopRecorder(); // 停止录音
        // 长按结束调用保存录音或者返回录音数据
        if (this.blackBoxSpeak) {
          // 未上滑取消
          console.warn("未上滑取消", this.nowDuration);
          if (this.nowDuration >= 1) {
            // this.$emit("closeAudio", this.recorder?.getWAVBlob());
            // console.log("松开>>>", this.getRecorder()?.wavBlob);
            this.closeAudio(this.getRecorder());
            console.log("流程完成");
          } else {
            this.closeAudio();
            this.$myToast({
              type: "fail",
              message: "录音时间过短",
              duration: 1000,
            });
          }
        } else {
          this.closeAudio();
          this.$myToast({
            type: "fail",
            message: "手动取消",
            duration: 1000,
          });
        }
        // console.log('松开>>>', this.getRecorder())
        this.nowDuration = 0;
        this.drawColuList = [];
        // 重新初始化录音机 可能也会导致声音问题
       /*  let initResult = this.initRecord()
        console.log('重新初始化录音机 initResult', initResult) */
      } else {
        console.log('*** this.timeOutEvent === 0', this.timeOutEvent)
        this.closeAudio();
      }
    },
    // 滑动触发
    touchmove(e) {
      if (!this.canUse) {
        return;
      }
      const endY = e?.targetTouches[0]?.clientY;
      this.blackBoxSpeak = this.startY < endY;

      // console.log("touchmove", this.blackBoxSpeak, this.startY, endY, e.target);
    },
    // 长按超过x毫秒-- 开始录音
    startRecorder() {
      console.log('enter startRecorder:' + this.formatTime(new Date()))
      this.recorder?.start().then(
        () => {
          console.log('this.beginRecoding:' + this.formatTime(new Date()))
          this.beginRecoding = true;
          this.changeASRText(this.asrStartText + ` 0:00`, false, this.textStatus)
          /*
          this.$nextTick(() => {
            try {
              // this.drawRecordWave(); //开始绘制
              // this.drawRecordColu(); // 开始绘制
            } catch (error) {
              console.error("drawRecordColu", error);
            }
          }); */
        },
        (error) => {
          console.error("startRecorder error", error);
          this.$myToast({
            type: "fail",
            message: error.message || "录音错误",
          });
        }
      );
    },
    // 继续录音
    resumeRecorder() {
      this.recorder?.resume();
    },
    // 暂停录音
    pauseRecorder() {
      this.recorder?.pause();
      this.drawRecordId && cancelAnimationFrame(this.drawRecordId);
      this.drawRecordId = null;
    },
    // 结束录音
    stopRecorder() {
      this.recorder?.stop();
      this.drawRecordId && cancelAnimationFrame(this.drawRecordId);
      this.drawRecordId = null;
    },
    // 录音播放
    playRecorder() {
      this.recorder?.play();
      // this.drawPlay();//绘制波浪图
    },
    // 暂停录音播放
    pausePlayRecorder() {
      this.recorder?.pausePlay();
    },
    // 恢复录音播放
    resumePlayRecorder() {
      this.recorder?.resumePlay();
      // this.drawPlay();//绘制波浪图
    },
    // 停止录音播放
    stopPlayRecorder() {
      this.recorder?.stopPlay();
    },
    // 获取录音文件
    getRecorder() {
      // let map = new Map();
      // map.set("duration", this.recorder?.duration); //录音总时长
      // map.set("fileSize", this.recorder?.fileSize); //录音总大小

      // //录音结束，获取取录音数据
      // map.set("PCMBlob", this.recorder?.getPCMBlob()); //获取 PCM 数据
      // map.set("wavBlob", this.recorder?.getWAVBlob()); //获取 WAV 数据
      // // map.set("mp3Blob", this.convertToMp3(this.recorder?.getWAV()));
      // map.set("channel", this.recorder?.getChannelData()); //获取左声道和右声道音频数据
      // return map;
      const map = {};
      map.duration = this.recorder?.duration; // 录音总时长
      map.fileSize = this.recorder?.fileSize; // 录音总大小

      // 录音结束，获取取录音数据
      map.PCMBlob = this.recorder?.getPCMBlob(); // 获取 PCM 数据
      map.wavBlob = this.recorder?.getWAVBlob(); // 获取 WAV 数据
      // map.mp3Blob = this.convertToMp3(this.recorder?.getWAV());
      map.channel = this.recorder?.getChannelData(); // 获取左声道和右声道音频数据
      return map;
    },
    // 下载pcm格式
    downPCM() {
      this.recorder?.downloadPCM("新文件"); // 这里传参进去的时文件名
    },
    // 下载wav格式
    downWAV() {
      this.recorder?.downloadWAV("新文件"); // 这里传参进去的时文件名
    },
    isRecording(){
      return this.beginRecoding
    },
    // 拆分数组
    splitArr(arr, rst, idx) {
      if (!arr || arr.length === 0) {
        return;
      }
      rst.push(arr.splice(0, idx || 32));
      this.splitArr(arr, rst);
    },
    // 取数组平均数
    arrAverageNum2(arr) {
      const sum = eval(arr.join("+"));
      return ~~((sum / arr.length) * 100) / 100;
    },
    // 关闭组件
    close() {
      // this.$emit("closeAudio");
      this.closeAudio();
    },
    // 销毁录音
    destroyRecorder() {
      console.log('enter destroyRecorder()')
      const vm = this;
      if (vm.recorder) {
        vm.recorder.destroy().then(function () {
          vm.recorder = null
          vm.drawRecordId && cancelAnimationFrame(vm.drawRecordId);
          vm.drawRecordId = null
        })
      }
    },
    destroyRecorderNew() {
      console.log('enter destroyRecorderNew()')
      this.stopRecorder()
      this.recorder = null
      const vm = this;
      if (vm.recorder) {
        vm.recorder.destroy().then(function () {
          vm.recorder = null
          vm.drawRecordId && cancelAnimationFrame(vm.drawRecordId);
          vm.drawRecordId = null
        })
      }
    },
    closeAudio(data) {
      this.isShow = false;

      // this.downPCM();
      // this.downWAV();

      this.beginRecoding = false
      this.changeASRShow(false);
      this.destroyRecorder(); // 不销毁，无法播放声音

      // this.playRecorder();
      // this.downMP3();
      // this.playAudio(window.URL.createObjectURL(data?.wavBlob));
      if (data) {
        this.$nextTick(async () => {
          try {
            // this.baiduASR(data?.PCMBlob);
            this.$emit('onBaiduASR', data?.PCMBlob) // 尝试换方式子组件提交 看能否对wx浏览器的主动触发音频有效
          } catch (error) {
            console.error(
              "🚀 ~ file: AudioEnter.vue:560 ~ this.$nextTick ~ error : ",
              error
            );
          }
        });
      }
      // this.getMyAudio()?.play?.(data?.wavBlob);
      // 处理其他逻辑......
    },
    formatTime(date){
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      const milliseconds = date.getMilliseconds();

      return  `${hours}:${minutes}:${seconds}.${milliseconds}`
    },
    // 文件格式转换 wav-map3
    downMP3() {
      const mp3Blob = this.convertToMp3(this.recorder?.getWAV());
      this.recorder?.download(mp3Blob, "recorder", "mp3");
    },
    // wav转换成mp3格式
    convertToMp3(wavDataView) {
      // 获取wav头信息
      const wav = lamejs.WavHeader.readHeader(wavDataView); // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
      const { channels, sampleRate } = wav;
      const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128);
      // 获取左右通道数据
      const result = this.recorder?.getChannelData();
      const buffer = [];

      const leftData =
        result.left &&
        new Int16Array(result.left.buffer, 0, result.left.byteLength / 2);
      const rightData =
        result.right &&
        new Int16Array(result.right.buffer, 0, result.right.byteLength / 2);
      const remaining = leftData.length + (rightData ? rightData.length : 0);

      const maxSamples = 1152;
      for (let i = 0; i < remaining; i += maxSamples) {
        const left = leftData.subarray(i, i + maxSamples);
        let right = null;
        let mp3buf = null;

        if (channels === 2) {
          right = rightData.subarray(i, i + maxSamples);
          mp3buf = mp3enc.encodeBuffer(left, right);
        } else {
          mp3buf = mp3enc.encodeBuffer(left);
        }

        if (mp3buf.length > 0) {
          buffer.push(mp3buf);
        }
      }
      const enc = mp3enc.flush();
      if (enc.length > 0) {
        buffer.push(enc);
      }
      return new Blob(buffer, { type: "audio/mp3" });
    },
    // 录音绘制波浪图
    drawRecordWave() {
      if (!this.recorder) return;
      // 用requestAnimationFrame稳定60fps绘制
      this.drawRecordId = requestAnimationFrame(this.drawRecordWave);
      // 实时获取音频大小数据
      let dataArray = this.recorder?.getRecordAnalyseData();
      //console.log('>>>',dataArray)
      let bufferLength = dataArray.length;

      // 填充背景色
      this.ctx.fillStyle = "rgb(0,0,0)";
      this.ctx.fillRect(0, 0, this.waveCanvas.width, this.waveCanvas.height);

      // 设定波形绘制颜色
      this.ctx.lineWidth = 2;
      this.ctx.strokeStyle = "rgb(109, 212, 0)";

      this.ctx.beginPath();
      let sliceWidth = (this.waveCanvas.width * 1.0) / bufferLength; // 一个点占多少位置，共有bufferLength个点要绘制
      let x = 0; // 绘制点的x轴位置
      for (var i = 0; i < bufferLength; i++) {
        var v = dataArray[i] / 128.0;
        var y = (v * this.waveCanvas.height) / 2;
        if (i === 0) {
          // 第一个点
          this.ctx.moveTo(x, y);
        } else {
          // 剩余的点
          this.ctx.lineTo(x, y);
        }
        // 依次平移，绘制所有点
        x += sliceWidth;
      }

      this.ctx.lineTo(this.waveCanvas.width, this.waveCanvas.height / 2);
      this.ctx.stroke();
    },
    // 录音绘制柱状图
    drawRecordColu() {
      if (!this.recorder) return;
      // 用requestAnimationFrame稳定60fps绘制(官方写法，录音过程中，会一直自我调用，因此能得到持续的数据，然后根据数据绘制音波图)
      this.drawRecordId = requestAnimationFrame(this.drawRecordColu);
      // 实时获取音频大小数据
      let dataArray = this.recorder?.getRecordAnalyseData();
      let transit = [];
      this.splitArr([...dataArray], transit);

      let rstArr = [];
      for (let i = 0; i < transit.length; i++) {
        rstArr.push(Math.max(...transit[i]));
      }
      this.drawColuList = [];
      for (var i = 0; i < rstArr.length; i++) {
        // var v = rstArr[i] / 128.0;
        // var h = v * this.waveCanvas.height / 3;
        // this.drawColuList.push(h)
        // 根据数值大小，设置音波柱状的高度
        let newDb = rstArr[i];
        const step = 10;
        let waveH = 4;
        if (newDb >= 128 && newDb <= 140) {
          waveH = waveH + step * 1;
        } else if (newDb >= 141 && newDb <= 160) {
          waveH = waveH + step * 2;
        } else if (newDb >= 161 && newDb <= 180) {
          waveH = waveH + step * 3;
        } else if (newDb >= 181 && newDb <= 200) {
          waveH = waveH + step * 4;
        } else if (newDb > 200) {
          waveH = waveH + step * 5;
        }
        this.drawColuList.push(waveH);
      }
      // console.log(this.drawColuList)
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped lang="less">
.waitting {
  font-size: 1.8em;
  line-height: 1.2;
  padding: 2em 0;
  color: #6dd400;
  text-align: center;
}
.audio-enter {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 999999999;
  background-color: #ffffff;
}
.custom-overlay {
  z-index: 200;
  min-height: 100vh;
  // background-color: rgba(0, 0, 0, 0.8);
}

.audio-pie {
  z-index: 10;
  position: absolute;
  left: 0;
  right: 0;
  // bottom: 100px;
  bottom: 200px;
  text-align: center;
  // transform: translateY(-50%);

  .audio-pie_txt {
    color: #ffffff;
    font-size: 1.3em;
    line-height: 1.2;
    padding-top: 1em;
  }
  .red-color {
    color: var(--red);
  }
  .audio-pie_audio--times {
    // height: 20px;
    font-size: 2em;
    font-weight: bold;
    color: #ffffff;
    line-height: 1.2;
    letter-spacing: 2px;
  }
  .audio-pie_audio--osc {
    width: 180px;
    height: 100px;
    // height: 44px;
    //      background: #6DD400;
    margin: 2em auto;
    display: flex;
    align-items: center;

    .audio-pie_audio--osc_item {
      width: 10px;
      background-color: rgba(109, 212, 0, 1);
      border-radius: 4px;
      border-radius: 1000px;

      &:not(:first-child) {
        margin-left: 3px;
      }
    }
  }
  // .audio-pie_btn {
  //   margin-top: 60px;

  //   .audio-pie_btn-icon {
  //     position: relative;
  //     width: 60px;
  //     height: 60px;
  //     background: #6dd400;
  //     border-radius: 100%;
  //     margin: 0 auto;

  //     .audio-pie_btn-icon1 {
  //       position: absolute;
  //       top: 12px;
  //       left: 0;
  //       right: 0;
  //       margin: 0 auto;
  //       width: 36px;
  //       height: 36px;
  //       border: 4px solid #fff;
  //       border-radius: 100%;
  //     }
  //     .audio-pie_btn-icon2 {
  //       position: absolute;
  //       top: 22px;
  //       left: 0;
  //       right: 0;
  //       margin: 0 auto;
  //       width: 16px;
  //       height: 16px;
  //       background-color: #fff;
  //       border-radius: 100%;
  //     }

  //     .iconfont {
  //       color: #ffffff;
  //       font-size: 35px;
  //       line-height: 60px;
  //     }
  //   }
  // }
}
.btn {
  background: #363636;
  border-radius: 8px;
  margin: auto;
  text-align: center;
  padding: 8px;
  user-select: none;
  line-height: 24px;
  height: unset;
  border: none;
  color: #fff;
  cursor: pointer;
}
.speak-btn {
  position: relative;
  z-index: 250;
  flex: 1;
}
</style>
